import React from 'react';
import UserProfile from './userProfile';
import UserData from './userData';
import { isXrole } from '../../utils/authentication';

function UserDetails({ id }) {
  return (
    <div className='relative'>
      <UserProfile id={id} />
      {isXrole('ADMIN_ROLE') && <UserData id={id} />}
    </div>
  );
}

export default React.memo(UserDetails);
